import React from 'react';
import '../../Styles/Pricing/FeatureCards.css';

export interface FeatureCardItem {
    icon: React.ReactNode;
    title: string;
    text: string;
}

interface FeatureCardsProps {
    items: FeatureCardItem[];
    label?: string;
}

const FeatureCards: React.FC<FeatureCardsProps> = ({ items, label }) => (
    <ul className="feature-cards" aria-label={label}>
        {items.map(item => (
            <li key={item.title} className="feature-cards-item">
                <span className="feature-cards-icon" aria-hidden>{item.icon}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
            </li>
        ))}
    </ul>
);

export default FeatureCards;
